import template from './episodelist.html';
import controller from './episodelist.controller';
import './episodelist.styl';

let episodelistComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default episodelistComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/episodelist/episodelist.component.js